import React from 'react';
import { useSelector } from 'react-redux';
import { FadeInImage } from 'components/FadeInImage';
import useProfiles from 'containers/NewProfiles/hooks/useProfiles';
import './style.scss';
import ProfileMenu from 'components/nav/menuUser/ProfileMenu';
import { getUserId } from 'containers/NewProfiles/selectors/profiles.selector';

export const Avatar = () => {
  const { home_anonymous_placeholder_img } = useSelector(state => state.asset);
  const { onClickIcon, getPerfilCurren } = useProfiles();
  const userId = useSelector(getUserId);
  const profile = getPerfilCurren();

  return (
    <li className="menu-opt-avatar" onClick={() => onClickIcon()}>
      {!userId ? (
        <FadeInImage
          imageSrc={home_anonymous_placeholder_img}
          imageAlt="avatar"
          width={33}
          height={33}
          classNames={['menu-opt-avatar__img']}
        />
      ) : (
        <ProfileMenu key={userId} profile={profile} />
      )}
    </li>
  );
};
